import { useEffect } from 'react';

import { Navigate, useNavigate } from 'react-router-dom';

import { MessageUpdateError } from 'components/Drawers/CadastralChange/components/Messages';
import { portugueseCadastralChangeName } from 'helpers';
import { newRelicMonitoringService } from 'services';
import { getRequestId } from 'services/create-request-id';
import { ErrorRegistration, useRegistrationControllerContext } from 'store';

export const RegistrationError = ({ type }: { type: string }) => {
  const navigate = useNavigate();
  const typePortuguese = portugueseCadastralChangeName[type];
  const { steps } = useRegistrationControllerContext();

  useEffect(() => {
    if (!steps.error?.errorMessage) {
      navigate('/perfil', { replace: true });
    }

    newRelicMonitoringService.addPageAction(`callback_alteracao_${typePortuguese}`, {
      error_message: steps.error?.errorMessage,
      error_code: steps.error?.errorId,
      session_id: getRequestId() || '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!steps.start || !steps.validate || !steps.error) {
    return <Navigate to='/perfil' replace />;
  }

  return (
    <MessageUpdateError error={steps.error as unknown as ErrorRegistration} type={typePortuguese} />
  );
};

export default RegistrationError;
